export default {
  meta: {
    title: '踩点宝-踩点分析报告',
    url: '/footprinting/home', // 埋点字段，上报归属的模块
    urlName: '踩点宝' // 埋点字段，上报归属的模块
  }
};
